/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { Row, Col } from 'react-grid-system';
import BlockUI from 'components/molecules/BlockUi';
import FormContents from 'components/atoms/Form/FormContents';
import useMonthlyAgreement36Form, { MonthlyInfoAgreement36Data } from './hooks';
// import CalendarForm from 'components/molecules/CalendarForm';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FlexBox from 'components/atoms/FlexBox';
import FormPadding from 'components/atoms/Form/FormPadding';
import FormLabel from 'components/atoms/Form/FormLabel';
import productColor from 'components/styles';
import SelectForm from "components/molecules/SelectForm";
import Checkbox from 'components/molecules/Checkbox';
import { Column } from 'react-table';
import DataTable from 'components/organismos/DataTable/DataTable';
import TextTooltip from 'components/molecules/TextTooltip';
import Modal from 'components/molecules/Modal';
import BodyText from 'components/atoms/BodyText';
import ModalDetailStaff from './../ModalDetailStaff'
import FormHeader from 'components/templates/FormHeader';
// import ClickableIconButton from 'components/atoms/ClickableIconButton';
// import Icon from 'components/atoms/Icon';
// import moment from 'moment';
import FormField from 'components/atoms/Form/FormField';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

const styles = {
  detailText: css({
    color: productColor.primary,
    '&:hover': {
      opacity: 0.8,
      cursor: 'pointer'
    },
    marginRight: '15px'
  }),
  tableModal: css({
    maxWidth: '1000px'
  }),
  labelTable: css({
    margin: '20px 0'
  }),
  tableStyles: css({
    overflow: 'hidden'
  },css`
    tr td:nth-child(4),
    tr td:nth-child(5),
    tr td:nth-child(6)
    {
      padding: 0px;
    }
  `)
};

const MonthlyAgreement36Form: React.FC = () => {
  const getOverTimeFlag = (flag: number) => {
    let tmpStyle = {
      margin: '0px',
      padding: '14px'
    };
    switch (flag) {
      case 1:
        return { ...tmpStyle, backgroundColor: productColor.copyAction }
      case 2:
        return { ...tmpStyle, backgroundColor: productColor.secondary }
      default:
        return tmpStyle
    }
  };

  const getOverHolidayTimeFlag = (flag: number) => {
    let tmpStyle = {
      margin: '0px',
      padding: '14px'
    };
    switch (flag) {
      case 2:
        return { ...tmpStyle, backgroundColor: productColor.secondary }
      default:
        return tmpStyle
    }
  };

  const getStyleLabel = (index: number, maxLength: number) => {
    switch (index) {
      case maxLength - 2:
        return css({ color: productColor.copyAction });
      case maxLength - 1:
        return css({ color: productColor.secondary });
      default:
        return css({});
    }
  };

  const {
    isLoading,
    applyDate,
    setApplyDate,
    orgCode,
    setOrgCode,
    orgTreesOptions,
    checkboxThreshold,
    setCheckboxThreshold,
    monthlyAgreement36Data,
    checkboxHoliday,
    setCheckboxHoliday,
    monthlyInfoData,
    isOpenModal,
    setIsOpenModal,
    handleOpenDetail,
    staffDetail,
  } = useMonthlyAgreement36Form();

  const columns: Array<Column<MonthlyInfoAgreement36Data>> = React.useMemo(() => [
    {
      Header: "スタッフ名",
      accessor: 'x',
      disableSortBy: true,
      id: 'actionButton',
      Cell: (cell: { row: { isExpanded: boolean, original: MonthlyInfoAgreement36Data } }) => {
        // eslint-disable-next-line
        return (
          <div style={{display: 'flex', 
                       flexDirection: 'row', 
                       justifyContent: 'space-between', 
                       alignContent: 'center', 
                       alignItems: 'center'}}
          >
            <TextTooltip text={cell.row.original.staffName} textDis={(
              <div className="ellipsis headline-cell-width-120" 
                   style={{textOverflow: 'ellipsis', 
                           whiteSpace: 'nowrap', 
                           overflow: 'hidden',
                           width: '140px'}}
              >
                <span>{cell.row.original.staffName}</span>
              </div>
            )}/>
            <BodyText 
              customStyle={styles.detailText} 
              onClick={() => handleOpenDetail(cell.row.original.staffCode)}
            >
              詳細
            </BodyText>  
          </div>       
        );
      }
    },
    {
      Header: '組織名',
      accessor: 'orgName'
    },
    {
      Header: '出勤予定残日数',
      accessor: 'remainDays',
      Cell: (cell: { row: { isExpanded: boolean, original: MonthlyInfoAgreement36Data } }) => {
        return (
          `${cell.row.original.remainDays ? cell.row.original.remainDays + '日' : ''}`
        )
      }
    },
    {
      Header: '法定外残業時間',
      accessor: 'overTimeHour',
      Cell: (cell: { row: { isExpanded: boolean, original: MonthlyInfoAgreement36Data } }) => {
        return (
          <div css={css(getOverTimeFlag(cell.row.original.overTimeFlag))}>
            {`${cell.row.original.overTimeHour}`}
          </div>
        )
      }
    },
    {
      Header: '休日出勤労働時間',
      accessor: 'holidayTimeHour',
      Cell: (cell: { row: { isExpanded: boolean, original: MonthlyInfoAgreement36Data } }) => {
        return `${cell.row.original.holidayTimeHour}`
      }
    },
    {
      Header: '合計',
      accessor: 'overHolidayTimeHour',
      Cell: (cell: { row: { isExpanded: boolean, original: MonthlyInfoAgreement36Data } }) => {
        return (
          <div css={css(getOverHolidayTimeFlag(cell.row.original.overHolidayTimeFlag))}>
            {`${cell.row.original.overHolidayTimeHour}`}
          </div>
        )
      }
    }
  ], [handleOpenDetail]);

  return (
    <BlockUI blocking={isLoading}>
      <FormHeader title="月次" />
      <FormContents customStyle={css({marginTop:'60px', paddingTop: '8px'})}>      
        <FormPadding>
          <FlexBox>
            <FormLabel label="営業月" customStyle={css({width: '100px', marginRight: '48px'})}/>
            <FlexBoxItem>
              <CalendarMonth 
              openActionChevron={true}
              date={applyDate}
              setDate={setApplyDate}
              />
            </FlexBoxItem>
            {/* <FlexBoxItem>
              <ClickableIconButton onClick={() => {
                setApplyDate(new Date(moment(applyDate).subtract(1, 'month').format('YYYY/MM/01')));
                sessionStorage.setItem('agreement36.applyTargetDate', moment(applyDate).subtract(1, 'month').format("YYYY/MM/DD"));
              }} additionalCss={css({ marginLeft: '-35px' })}>
                <Icon type="chevronLeft" color="" size="24px" />
              </ClickableIconButton>
            </FlexBoxItem>
            <FlexBoxItem width="160px">
              <CalendarForm
                required={true}
                label=""
                date={applyDate}
                dateFormat="YYYY/MM"
                changeDate={(date: Date) => {
                  if(date.getMonth() !== applyDate.getMonth() || date.getFullYear() !== applyDate.getFullYear()) {
                    setApplyDate(date)
                  }
                }} 
              />
            </FlexBoxItem>
            <FlexBoxItem>
              <ClickableIconButton onClick={() => {
                setApplyDate(new Date(moment(applyDate).add(1, 'month').format('YYYY/MM/01')));
              }}>
                <Icon type="chevronRight" color="" size="24px" />
              </ClickableIconButton>
            </FlexBoxItem> */}
          </FlexBox>
        </FormPadding>
        <FormField displayBlock={true} customStyle={css({margin: '0px 15px'})}>
          <Row>
            <Col xl={6} md={12} xs={12} >
              <FlexBox>
                <FlexBoxItem width='100px' customStyle={css({paddingRight: '49px'})}>
                  <FormLabel label="組織"/>
                </FlexBoxItem>
                <FlexBoxItem grow={1} width='150px'>
                  <SelectForm
                    label=""
                    name="orgCode"
                    value={String(orgCode)}
                    setValue={(v) => {setOrgCode(v);}}
                    options={orgTreesOptions}
                    description=""
                    ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgTreesOptions.length === 1)}
                  />
                </FlexBoxItem>
              </FlexBox>                
            </Col>
          </Row>
        </FormField>
        <FormPadding>
          <FlexBox>
            <FormLabel label="法定外残業" customStyle={css({margin: '0', width: '150px'})}/>
            {monthlyAgreement36Data.monthlyOvertimeHourList?.map((item, index) => (
              <FlexBoxItem customStyle={css({ marginRight: '20px' })}>
                <Checkbox
                  id={`checkboxThreshold${index}`}
                  name={`checkboxThreshold${index}`}
                  label={`${item}時間を超過`}
                  value={`checkboxThreshold${index}`}
                  checked={checkboxThreshold[index]}
                  onChange={() => {
                    let tmpList = [...checkboxThreshold];
                    tmpList[index] = !tmpList[index];
                    setCheckboxThreshold(tmpList);
                  }}
                  customStyleLabel={getStyleLabel(index, monthlyAgreement36Data.monthlyOvertimeHourList?.length || 0)}
                />
              </FlexBoxItem>
            ))}
          </FlexBox>
        </FormPadding>
        <FormPadding>
          <FlexBox>
            <FormLabel label="法定外と休日出勤" customStyle={css({margin: '0', width: '150px'})}/>
            {!!monthlyAgreement36Data.monthlyOverAndHolidayTimeHour && (
              <FlexBoxItem customStyle={css({ marginRight: '20px' })}>
                <Checkbox
                  id={`monthlyOverAndHolidayTime`}
                  name={`monthlyOverAndHolidayTime`}
                  label={`${monthlyAgreement36Data.monthlyOverAndHolidayTimeHour}時間を超過`}
                  value={`monthlyOverAndHolidayTime`}
                  checked={checkboxHoliday}
                  onChange={() => {setCheckboxHoliday(!checkboxHoliday)}}
                  customStyleLabel={getStyleLabel(0, 1)}
                />
              </FlexBoxItem>
            )}
          </FlexBox>
        </FormPadding>
        <div 
          className='table-bordered table-padding' 
          css={css`
            white-space: nowrap;
            overflow-x: auto;
            padding-bottom: 15px;
            table th:nth-of-type(1) {
              width: 170px;
            }
            table td:nth-of-type(1) {
              text-align: left;
            }
            table th:nth-of-type(2) {
              width: 140px;
            }        
            table th:nth-of-type(3) {
              width: 120px;
            }       
            table th:nth-of-type(4) {
              width: 140px;
            }          
            table th:nth-of-type(5) {
              width: 140px;
            }      
            table th:nth-of-type(6) {
              width: 140px;
            }
            table td:nth-of-type(n+3) {
              text-align: center;
            }
          `}
        >
          <DataTable 
            className="table-no-border-left-right"
            classNameParrant="border-left-right"
            columns={columns}
            data={monthlyInfoData || []}
            isGlobalFilter={false}
            minWidth="100%"
            customStyle={styles.tableStyles}
          />
        </div>
      </FormContents>
      <Modal
        open={isOpenModal}
        closeHandler={() => setIsOpenModal(false)}
        title="時間外労働一覧"
        submitText=""
        closeText="閉じる"
        onSubmit={() => { }}
      >
        {!isLoading && staffDetail && staffDetail.length > 0 && (
          <ModalDetailStaff
            staffDetail={staffDetail}
          />
        )}
      </Modal>
    </BlockUI>
  );
};

export default MonthlyAgreement36Form;
